(function () {
  if (window.efgSimpleSliderLoaded) {
    if (window.efgSimpleSliderInitAll) {
      window.efgSimpleSliderInitAll(document);
    }
    return;
  }

  window.efgSimpleSliderLoaded = true;

  function getSlides(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-efg-simple-slider-slide]')
    );
  }

  function getDots(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll('[data-efg-simple-slider-dot]')
    );
  }

  function normalizeIndex(root, nextIndex) {
    var slides = getSlides(root);
    var loop = root.getAttribute('data-loop') === 'true';

    if (!slides.length) return 0;

    if (loop) {
      return (nextIndex + slides.length) % slides.length;
    }

    return Math.max(0, Math.min(nextIndex, slides.length - 1));
  }

  function goTo(root, nextIndex) {
    var track = root.querySelector('[data-efg-simple-slider-track]');
    var slides = getSlides(root);
    var dots = getDots(root);

    if (!track || !slides.length) return;

    var index = normalizeIndex(root, nextIndex);

    root._efgCurrentIndex = index;

    track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';

    slides.forEach(function (slide, slideIndex) {
      var isActive = slideIndex === index;

      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
    });

    dots.forEach(function (dot, dotIndex) {
      var isActive = dotIndex === index;

      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function stopAutoplay(root) {
    if (root._efgTimer) {
      clearInterval(root._efgTimer);
      root._efgTimer = null;
    }
  }

  function startAutoplay(root) {
    stopAutoplay(root);

    var slides = getSlides(root);
    var autoplay = root.getAttribute('data-autoplay') === 'true';
    var speed = parseInt(root.getAttribute('data-autoplay-speed'), 10) || 4500;

    if (!autoplay || slides.length < 2) return;

    root._efgTimer = setInterval(function () {
      var current = root._efgCurrentIndex || 0;
      goTo(root, current + 1);
    }, speed);
  }

  function forceBaseStyles(root) {
    var viewport = root.querySelector('[data-efg-simple-slider-viewport]');
    var track = root.querySelector('[data-efg-simple-slider-track]');
    var slides = getSlides(root);

    if (viewport) {
      viewport.style.overflow = 'hidden';
    }

    if (track) {
      track.style.display = 'flex';
      track.style.width = '100%';
      track.style.transform = track.style.transform || 'translate3d(0, 0, 0)';
    }

    slides.forEach(function (slide) {
      slide.style.flex = '0 0 100%';
      slide.style.minWidth = '100%';
      slide.style.width = '100%';
    });
  }

  function initSlider(root) {
    if (!root) return;

    var viewport = root.querySelector('[data-efg-simple-slider-viewport]');
    var track = root.querySelector('[data-efg-simple-slider-track]');
    var slides = getSlides(root);

    if (!viewport || !track || slides.length < 1) return;

    forceBaseStyles(root);

    root._efgCurrentIndex = root._efgCurrentIndex || 0;

    goTo(root, root._efgCurrentIndex);
    startAutoplay(root);

    if (root._efgEventsReady) return;

    root._efgEventsReady = true;

    var startX = 0;
    var startY = 0;
    var isDragging = false;

    viewport.addEventListener('pointerdown', function (event) {
      if (getSlides(root).length < 2) return;

      isDragging = true;
      startX = event.clientX;
      startY = event.clientY;

      stopAutoplay(root);
    });

    viewport.addEventListener('pointerup', function (event) {
      if (!isDragging) return;

      isDragging = false;

      var diffX = event.clientX - startX;
      var diffY = event.clientY - startY;

      if (Math.abs(diffX) > 45 && Math.abs(diffX) > Math.abs(diffY)) {
        var current = root._efgCurrentIndex || 0;

        if (diffX < 0) {
          goTo(root, current + 1);
        } else {
          goTo(root, current - 1);
        }
      }

      startAutoplay(root);
    });

    viewport.addEventListener('pointercancel', function () {
      isDragging = false;
      startAutoplay(root);
    });

    viewport.addEventListener('pointerleave', function () {
      isDragging = false;
      startAutoplay(root);
    });

    root.addEventListener('mouseenter', function () {
      stopAutoplay(root);
    });

    root.addEventListener('mouseleave', function () {
      startAutoplay(root);
    });
  }

  function initAll(scope) {
    var container = scope || document;
    var sliders = container.querySelectorAll('[data-efg-simple-slider]');

    sliders.forEach(function (slider) {
      initSlider(slider);
    });
  }

  document.addEventListener('click', function (event) {
    var dot = event.target.closest('[data-efg-simple-slider-dot]');
    if (!dot) return;

    var slider = dot.closest('[data-efg-simple-slider]');
    if (!slider) return;

    event.preventDefault();

    var index = parseInt(dot.getAttribute('data-slide-index'), 10);

    if (isNaN(index)) return;

    goTo(slider, index);
    startAutoplay(slider);
  });

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  window.addEventListener('load', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('[data-efg-simple-slider-slide]');
    if (!slide) return;

    var slider = slide.closest('[data-efg-simple-slider]');
    if (!slider) return;

    var index = parseInt(slide.getAttribute('data-slide-index'), 10) || 0;

    initSlider(slider);
    goTo(slider, index);
  });

  window.efgSimpleSliderInitAll = initAll;
  window.efgSimpleSliderGoTo = goTo;

  initAll(document);
})();